/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/leaf'
export default icon
